import { render, staticRenderFns } from "./StoredPoints.vue?vue&type=template&id=7a1bf23c"
import script from "./StoredPoints.vue?vue&type=script&lang=js"
export * from "./StoredPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports